import { Alpine } from '../../../../vendor/livewire/livewire/dist/livewire.esm';

Alpine.directive('smooth-transition', (el, { modifiers }, { Alpine, cleanup }) => {
    if (!el.hasAttribute('wire:ignore.self')) {
        return console.error('smooth transition must be used inside a wire:ignore.self element', el);
    }

    const duration = modifierValue(modifiers, 'duration', 300) / 1000;
    const ease = modifierValue(modifiers, 'ease', 'ease-linear');
    const overflow = modifierValue(modifiers, 'overflow', 'hidden');

    let currentTarget = null;

    const resizeObserver = new ResizeObserver(entries => {
        entries.forEach(entry => {
            if (entry.contentRect.height > 0) {
                handleResize(entry.target.clientHeight);
            }
        });
    });

    // Watch for children being added/removed (Livewire renders content async)
    const mutationObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (mutation.type === 'childList') {
                const child = el.children[0];
                if (child && child !== currentTarget) {
                    teardown();
                    attachToTarget(child);
                } else if (!child && currentTarget) {
                    teardown();
                }
            }
        }
    });

    mutationObserver.observe(el, { childList: true });

    // Try immediate init in case child already exists
    Alpine.nextTick(() => {
        const child = el.children[0];
        if (child) {
            attachToTarget(child);
        }
    });

    cleanup(() => {
        resizeObserver.disconnect();
        mutationObserver.disconnect();
        currentTarget = null;
    });

    function attachToTarget(target) {
        currentTarget = target;
        el.classList.add('transition-all', ease);
        el.style.transitionDuration = `${duration}s`;

        if (target.clientHeight > 0) {
            el.style.height = target.clientHeight + 'px';
        }

        resizeObserver.observe(target);
    }

    function teardown() {
        if (currentTarget) {
            resizeObserver.unobserve(currentTarget);
        }
        currentTarget = null;
    }

    function handleResize(height) {
        const store = Alpine.store('modal');
        const useOpacity = !(store && store.withOpacity === false);

        el.style.overflow = overflow;

        if (currentTarget && useOpacity) {
            currentTarget.style.opacity = '0';
        }

        el.style.height = height + 'px';

        setTimeout(() => {
            el.style.overflow = null;
            if (currentTarget && useOpacity) {
                currentTarget.style.opacity = '1';
            }
        }, duration * 1100);
    }

    function modifierValue(modifiers, value, notFoundValue) {
        const index = modifiers.indexOf(value);
        if (index === -1) return notFoundValue;
        return modifiers[index + 1] ?? notFoundValue;
    }
});
